import styled from "styled-components"

export const Title = styled.h2`
  margin: 0 0 1.5rem;
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0;
  color: var(--muted);
`

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.25rem 1.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
  @media (min-width: 992px) {
    gap: 1.5rem 2.75rem;
  }
  li {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 40px;
  }
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: grayscale(1);
    opacity: 0.7;
    transition: filter 0.2s ease, opacity 0.2s ease;
  }
  li:hover img {
    filter: none;
    opacity: 1;
  }
  @media (min-width: 768px) {
    li {
      width: 140px;
      height: 52px;
    }
  }
`
